import type { WaitlistField } from './waitlist';

const GENERIC_WAITLIST_ERROR = 'A feliratkozás most nem küldhető el. Kérjük, próbáld újra később.';
const DEFAULT_WAITLIST_SUCCESS = 'Köszönjük, felvettünk az Orienta beta várólistára.';

type WaitlistResponseBody = {
  success?: boolean;
  message?: string;
  error?: string;
  field?: string;
};

export type WaitlistClientResult =
  | { ok: true; message: string }
  | { ok: false; message: string; field?: WaitlistField };

const WAITLIST_FIELDS = new Set<WaitlistField>(['email', 'name', 'company', 'role', 'companyType', 'interest', 'message']);

export async function parseWaitlistResponse(response: Response): Promise<WaitlistClientResult> {
  const contentType = response.headers.get('content-type')?.toLowerCase() ?? '';
  if (!contentType.includes('application/json')) {
    return { ok: false, message: GENERIC_WAITLIST_ERROR };
  }

  let body: WaitlistResponseBody;
  try {
    body = (await response.json()) as WaitlistResponseBody;
  } catch {
    return { ok: false, message: GENERIC_WAITLIST_ERROR };
  }

  if (response.ok && body.success) {
    return { ok: true, message: cleanMessage(body.message) || DEFAULT_WAITLIST_SUCCESS };
  }

  const field = isWaitlistField(body.field) ? body.field : undefined;
  return {
    ok: false,
    message: cleanMessage(body.error) || GENERIC_WAITLIST_ERROR,
    ...(field ? { field } : {})
  };
}

function cleanMessage(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

function isWaitlistField(value: unknown): value is WaitlistField {
  return typeof value === 'string' && WAITLIST_FIELDS.has(value as WaitlistField);
}
